import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaAngleLeft,
  FaAngleRight,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

interface PaginationProps {
  url: string;
  paginator: {
    number: number;
    totalPages: number;
    totalElements: number;
    first: boolean;
    last: boolean;
  };
}

const Pagination = ({ url, paginator }: PaginationProps) => {
  const navigate = useNavigate();
  const currentPage = paginator?.number;
  const totalPages = paginator?.totalPages || 0;
  const first = paginator?.first || false;
  const last = paginator?.last || false;

  const visiblePageCount = 5;
  const startPage = Math.max(0, currentPage - Math.floor(visiblePageCount / 2));
  const endPage = Math.min(startPage + visiblePageCount - 1, totalPages - 1);

  const handlePageChange = (page: number) => {
    if (page >= 0 && page < totalPages) {
      navigate(`${url}/page/${page}`);
    }
  };

  return (
    <div className="flex flex-col gap-3 border-t border-stroke px-4 pt-5 dark:border-strokedark md:flex-row md:justify-between md:px-8">
      {/* Texto Informativo (Responsive) */}
      <p className="text-center font-medium md:text-left">
        Mostrando {currentPage + 1} de {totalPages} páginas
      </p>

      {/* Contenedor del paginador */}
      <nav className="flex justify-center">
        <ul className="flex items-center">
          {/* Botón de Primera Página */}
          <li>
            <button
              onClick={() => handlePageChange(0)}
              disabled={first}
              className={`flex h-9 w-9 items-center justify-center rounded-l-md border border-stroke ${
                first
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'hover:border-primary hover:bg-gray hover:text-primary dark:hover:border-primary dark:hover:bg-graydark'
              }`}
            >
              <FaAngleDoubleLeft />
            </button>
          </li>

          {/* Botón Anterior */}
          <li>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={first}
              className={`flex h-9 w-9 items-center justify-center border border-stroke ${
                first
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'hover:border-primary hover:bg-gray hover:text-primary dark:hover:border-primary dark:hover:bg-graydark'
              }`}
            >
              <FaAngleLeft />
            </button>
          </li>

          {/* Números de Página */}
          {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
            <li key={startPage + index}>
              <button
                onClick={() => handlePageChange(startPage + index)}
                className={`flex items-center justify-center border border-stroke px-4 py-[5px] font-medium ${
                  currentPage === startPage + index
                    ? 'bg-primary text-white'
                    : 'hover:border-primary hover:bg-gray hover:text-primary dark:hover:border-primary dark:hover:bg-graydark'
                }`}
              >
                {startPage + index + 1}
              </button>
            </li>
          ))}

          {/* Botón Siguiente */}
          <li>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={last}
              className={`flex h-9 w-9 items-center justify-center border border-stroke ${
                last
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'hover:border-primary hover:bg-gray hover:text-primary dark:hover:border-primary dark:hover:bg-graydark'
              }`}
            >
              <FaAngleRight />
            </button>
          </li>

          {/* Botón Última Página */}
          <li>
            <button
              onClick={() => handlePageChange(totalPages - 1)}
              disabled={last}
              className={`flex h-9 w-9 items-center justify-center rounded-r-md border border-stroke ${
                last
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'hover:border-primary hover:bg-gray hover:text-primary dark:hover:border-primary dark:hover:bg-graydark'
              }`}
            >
              <FaAngleDoubleRight />
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
